import type { ComputedRef, Ref } from 'vue'
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import type {
    ReadyToGoRingFragment,
    ReadyToGoRingVariationsFragment,
} from '@/graphql/api'
import { useRoutes } from '@/router/routes'

export function useVariationIndex(
    variations: Readonly<Ref<ReadyToGoRingVariationsFragment[]>>,
    ring: Readonly<Ref<ReadyToGoRingFragment | null | undefined>>
): ComputedRef<string> {
    const router = useRouter()
    const routes = useRoutes()

    return computed<string>({
        get: () =>
            String(
                variations.value.findIndex(
                    (variation) =>
                        variation.catalogueCode === ring.value?.catalogueCode
                )
            ),
        set(value: string) {
            const variation = variations.value[Number(value)]
            if (variation !== undefined) {
                router.push(routes.ring.readyToGo(variation))
            }
        },
    })
}
